import { render, staticRenderFns } from "./CoinPackage.vue?vue&type=template&id=3e83096e&scoped=true"
import script from "./CoinPackage.vue?vue&type=script&lang=js"
export * from "./CoinPackage.vue?vue&type=script&lang=js"
import style0 from "./CoinPackage.vue?vue&type=style&index=0&id=3e83096e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83096e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e83096e')) {
      api.createRecord('3e83096e', component.options)
    } else {
      api.reload('3e83096e', component.options)
    }
    module.hot.accept("./CoinPackage.vue?vue&type=template&id=3e83096e&scoped=true", function () {
      api.rerender('3e83096e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/CoinPackage.vue"
export default component.exports